import { createContext } from 'react'

export interface MegaModuleContextType {
  size: 1 | 2 | 3 | 4 | 5
  accentColor: string
}

const MegaModuleContext = createContext<MegaModuleContextType | null>(null)

const exports = { MegaModuleContext }

export default exports
